import Spinner from 'react-bootstrap/Spinner';

type AppSpinnerProps = {
  animation?: 'border' | 'grow';
  dimension?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  color?: string;
};

const dimensionMapper = {
  xs: '1rem',
  sm: '2rem',
  md: '3rem',
  lg: '5rem',
  xl: '7rem',
  xxl: '9rem',
} as const;

export default function AppSpinner(props: Readonly<AppSpinnerProps>) {
  const { animation = 'border', dimension = 'lg', color = '#212529' } = props;

  return (
    <div
      data-testid="app-spinner"
      style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}
    >
      <Spinner
        data-testid="spinner"
        animation={animation}
        style={{ width: dimensionMapper[dimension], height: dimensionMapper[dimension], color }}
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}
